module.exports = __webpack_public_path__ + "img/ic_baby.4a08c1df.svg";